import { styled } from '@porsche-code/kado-styled-system/jsx';
import React from 'react';

const Component = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'md',
    backgroundColor: 'background.canvas',
  },

  variants: {
    spacing: {
      none: {},
      lg: {
        marginTop: 'lg',
      },
      md: {
        marginTop: 'md',
      },
    },
    centered: {
      true: {
        justifyContent: 'center',
      },
    },
    fullWidth: {
      true: {
        '& > *': {
          flex: '1 1 100%',
        },
      },
    },
  },
});

export const ActionGroup = ({
  spacing = 'lg',
  fullWidth,
  centered,
  children,
  ...props
}: {
  spacing?: 'none' | 'lg' | 'md';
  fullWidth?: boolean;
  centered?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <Component
      spacing={spacing}
      centered={centered}
      fullWidth={fullWidth}
      {...props}
    >
      {children}
    </Component>
  );
};
